<!--1048179141422-hoo16tcad7sd2escm87su1hi29glt2e2.apps.googleusercontent.com-->
<!--S4mlGlf3PM0UHOG9YXPcoY0R-->

<div class="container" style="max-width: 500px">
  <button
    type="button"
    (click)="googleSignin()"
    class="btn btn-block btn-primary"
    *ngIf="!isSignedin"
  >
    Sign Up with Google
  </button>

  <div *ngIf="isSignedin === true" class="mt-4">
    <h1 class="congrats">
      Congrats {{ user.firstName }}! You've now signed up with us!
    </h1>

    <div class="info">
      <img [src]="user.photoUrl" [alt]="user.name" />
      <h2>{{ user.name }}</h2>
      <p>{{ user.email }}</p>
    </div>

    <button type="button" (click)="logout()" class="btn btn-block btn-danger">
      Log Out
    </button>
  </div>
</div>
